document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".textarea-el").forEach((el) => {
    // Prevent double initialization
    if (el.classList.contains("quill-initialized")) return;

    const quill = new Quill(el, {
      theme: "snow",
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link"],
        ],
      },
    });

    el.classList.add("quill-initialized");

    // Optional: store reference globally if you need it
    window.quillEditors = window.quillEditors || [];
    const textarea = el.nextElementSibling;
    window.quillEditors.push({ quill, textarea });
  });
});
